import { MediaQuery } from '@grandvisionhq/common';

function usePromoIndices(productCount, hasPromotionSmall) {
    const currentBreakpoint = MediaQuery.useBreakpoint();
    switch(currentBreakpoint){
        case MediaQuery.BreakpointName.PHONE:
        case MediaQuery.BreakpointName.TABLET_PORTRAIT:
        case MediaQuery.BreakpointName.TABLET_LANDSCAPE:
            return {
                smallPromoIndex: 4,
                bigPromoIndex: hasPromotionSmall ? 13 : 4
            };
        case MediaQuery.BreakpointName.DESKTOP:
            return {
                smallPromoIndex: 5,
                bigPromoIndex: hasPromotionSmall ? productCount > 16 ? 17 : 13 : 5
            };
        default:
            return {
                smallPromoIndex: -1,
                bigPromoIndex: -1
            };
    }
}

export { usePromoIndices };
//# sourceMappingURL=use-promo-indices.js.map
